import moment from "moment";
import platePatternUtils from "../../../../../utils/plate-pattern-utils.js";

export default function ReportContent({ data, tableColumns }) {

    const parseJson = (value) => {
        if (!value) return null;
        if (typeof value === "object") return value;

        try {
            return JSON.parse(value);
        } catch (e) {
            console.error(e);
            return null;
        }
    };

    const getRowValues = (element) => {
        const externPayload = parseJson(element.extern_payload);
        const reasons = externPayload?.occurrences?.map(o => o.reason).join(", ") ?? "";
        const sign = parseJson(element.sign);
        const signUserAndDate = [];

        if (sign?.userName) signUserAndDate.push(sign.userName);
        if (sign?.dtSign) signUserAndDate.push(moment(sign.dtSign).format("DD/MM/YYYY HH:mm:ss"));

        const options = [];
        if (sign?.approached === true) options.push("Abordado");
        if (sign?.presentedDp === true) options.push("Apresentado ao DP");
        if (sign?.sendCloseOwnerWanted === true) options.push("Inativar monitoramento no Córtex");
        if (sign?.misreading === true) options.push("Leitura incorreta");

        return {
            capture_time: element.capture_time ?? "",
            dt_event: element.dt_event ?? "",
            plate_or_cpf: element.plate ? platePatternUtils.formatPlate(element.plate) : element.cpf,
            reasons,
            signature: signUserAndDate.join(" - "),
            options: options.join(", "),
            observation: sign?.observation ?? "",
            source: element.type ?? "",
            has_passage: element.has_passage ? "Sim" : "Não"
        };
    };
    const columns = [
        {id: "capture_time", label: "D/H de captura", className: "w-[9%]", getValue: values => values.capture_time},
        {id: "dt_event", label: "D/H do evento", className: "w-[9%]", getValue: values => values.dt_event},
        {id: "plate_or_cpf", label: "Placa ou CPF", className: "w-[8%]", getValue: values => values.plate_or_cpf},
        {id: "reasons", label: "Natureza", className: "w-[14%]", getValue: values => values.reasons},
        {id: "signature", label: "Assinatura", className: "w-[8%]", getValue: values => values.signature},
        {id: "options", label: "Opções", className: "w-[8%]", getValue: values => values.options},
        {id: "observation", label: "Observação", className: "w-[14%]", getValue: values => values.observation},
        {id: "source", label: "Origem do evento", className: "w-[14%]", getValue: values => values.source},
        {id: "has_passage", label: "Passagem do Sentry", className: "w-[8%]", getValue: values => values.has_passage}
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table id="integration-events-data" className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`} sheet-name="Eventos de integrações">
                <thead className="thead-background print:table-row-group!">
                    <tr className="bg-#f6f6f6 text-left">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {data.map((element, index) => {
                        const rowValues = getRowValues(element);
                        return (
                            <tr key={element.id ?? index}>
                                {visibleColumns.map(column => <td key={column.id} className={column.className}>{column.getValue(rowValues)}</td>)}
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            <div id="chart-tables"/>
        </>
    )
}